import { FC } from 'react';
import { observer } from 'mobx-react-lite';

import { CalloutBanner } from '@components/CalloutBanner';
import { Trans } from '@libs/i18n';

interface CompletionBannerProps {
  domainCount: number;
  documentCount: number;
}

export const CompletionBanner: FC<CompletionBannerProps> = observer(
  ({ domainCount, documentCount }) => (
    <CalloutBanner
      tone="success"
      title={
        <>
          <span role="img" aria-label="celebration">
            🎉
          </span>{' '}
          <Trans i18nKey="assessments.summary.completionMessage" />
        </>
      }
    >
      <Trans
        i18nKey="assessments.summary.completionSubtitle"
        values={{ domainCount, documentCount }}
      />
    </CalloutBanner>
  ),
);
